import { AxisSwitcher, BorderGridContainer, ContentTile, GridBox } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';

import getFootnoteSerializer from '../../utils/get-footnote-serializer';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../utils/uncap-fp-iterator';
import type { Tile } from './types';

const mapWithIndex = uncapFpIterator(map);

const amountOfColumns = 2;
const largeThreshold = '60rem';

type Props = {
  contentTiles: Tile[][];
};

const ContentTilesSection = ({ contentTiles }: Props) => {
  if (isEmpty(contentTiles)) {
    return null;
  }

  return (
    <>
      {mapWithIndex(
        (tiles: Tile[], index: number) => (
          <BorderGridContainer key={index}>
            <AxisSwitcher limit={amountOfColumns} threshold={largeThreshold}>
              {mapWithIndex((tile: Tile, tileIndex: number) => {
                const footnote = tile?.footnote;
                const formattedCtas = map((cta) => ({ ...cta, link: cta.url, linkText: cta.name }), tile.ctas);
                const formattedTile = { ...tile, ctas: formattedCtas };
                return (
                  <GridBox key={tileIndex} padding="1rem">
                    <ContentTile
                      {...formattedTile}
                      customSerializers={footnote ? getFootnoteSerializer({ footnote, variant: styles.footnote }) : {}}
                    />
                  </GridBox>
                );
              }, tiles)}
            </AxisSwitcher>
          </BorderGridContainer>
        ),
        contentTiles,
      )}
    </>
  );
};

export default ContentTilesSection;
